import {
  BrowserRouter,
  Routes,
  Route,
  NavLink,
  useNavigate,
  useLocation,
} from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import Enterprise from "./pages/Enterprise";
import Teams from "./pages/Teams";
import ContactSales from "./pages/ContactSales";
import Landing from "./pages/Landing";
import Features from "./pages/Features";
import HowItWorks from "./pages/HowItWorks";
import Contact from "./pages/Contact";
import Pricing from "./pages/Pricing";
import { DEMO_LINK, openBooking } from "./components/demoBooking";
import BookingOverlay from "./components/booking/BookingOverlay";
import CookieChoices from "./components/CookieChoices";
import BookingPage from "./components/booking/BookingPage";
import afterPaint from "./components/afterPaint";
import bossdroplogo from "./images/otherlogowhite-190.webp";
import bossdroplogo2x from "./images/otherlogowhite-380.webp";
import bossdroplogo3x from "./images/otherlogowhite-570.webp";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Blog from "./pages/Blog";
import Compare from "./pages/Compare";
import Specialists from "./pages/Specialists";
import SpecialistLogin from "./pages/SpecialistLogin";
import SpecialistDashboard from "./pages/SpecialistDashboard";

import Blog_AiProjectManagement from "./pages/Blog Posts/Blog_AiProjectManagement";
import Blog_LessMeetings from "./pages/Blog Posts/Blog_LessMeetings";
import Blog_ManagerlessSprint from "./pages/Blog Posts/Blog_ManagerlessSprint";
import Blog_TheNewKPI from "./pages/Blog Posts/Blog_TheNewKPI";
import Blog_AgenticRACI from "./pages/Blog Posts/Blog_AgenticRACI";
import Blog_ProjectUpdatesAIFixes from "./pages/Blog Posts/Blog_WhyProjectUpdatesAIFixes";
import Blog_AutomationDebtWorkflowSprawl from "./pages/Blog Posts/Blog_AutomationDebtWorkflowSprawl";
import Blog_DecisionLatency from "./pages/Blog Posts/Blog_DecisionLatency";
import Blog_AuditReadyAutomation from "./pages/Blog Posts/Blog_AuditReadyAutomation";
import Blog_SpanOfControl from "./pages/Blog Posts/Blog_SpanOfControl";
import Blog_ContextSwitchingTax from "./pages/Blog Posts/Blog_ContextSwitchingTax";
import Blog_ShadowAI from "./pages/Blog Posts/Blog_ShadowAI";
import Blog_OnboardingRunbooks from "./pages/Blog Posts/Blog_OnboardingRunbooks";
import Blog_CapacityPlanning from "./pages/Blog Posts/Blog_CapacityPlanning";
import Blog_EscalationLadder from "./pages/Blog Posts/Blog_EscalationLadder";

import BackToTop from "./components/BackToTop";
import "./index.css";

// The logo shows 190 x 38 in the header and a little smaller in the footer.
const LOGO_SRCSET = `${bossdroplogo} 1x, ${bossdroplogo2x} 2x, ${bossdroplogo3x} 3x`;

export default function App() {
  return (
    <BrowserRouter>
      <SiteHeader />
      <Backdrop />
      <main className="routeScroll">
        {/* Scroll-reveal bootstrapping */}
        <ScrollToTop />
        <RevealOnScroll />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/features" element={<Features />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/enterprise" element={<Enterprise />} />
          <Route path="/teams" element={<Teams />} />
          <Route path="/contact" element={<Contact />} />
          {/* The old demo form page: now forwards to the booking page. */}
          <Route path="/book-a-demo" element={<BookingPage />} />
          <Route path="/contact-sales" element={<ContactSales />} />
          <Route path="/specialists" element={<Specialists />} />
          <Route path="/specialists/login" element={<SpecialistLogin />} />
          <Route path="/specialists/dashboard" element={<SpecialistDashboard />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/compare/:slug" element={<Compare />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/blog" element={<Blog />} />
          <Route
            path="/blog/ai-project-management-with-bossdrop"
            element={<Blog_AiProjectManagement />}
          />{" "}
          <Route
            path="/blog/fewer-meetings-with-bossdrop-ai"
            element={<Blog_LessMeetings />}
          />{" "}
          <Route
            path="/blog/managerless-sprint-bossdrop-ai-2029"
            element={<Blog_ManagerlessSprint />}
          />{" "}
          <Route
            path="/blog/the-new-kpi-time-saved-by-ai"
            element={<Blog_TheNewKPI />}
          />
          <Route path="/blog/agentic-raci" element={<Blog_AgenticRACI />} />{" "}
          <Route
            path="/blog/why-project-updates-still-waste-hours"
            element={<Blog_ProjectUpdatesAIFixes />}
          />
          <Route
            path="/blog/automation-debt-workflow-sprawl"
            element={<Blog_AutomationDebtWorkflowSprawl />}
          />{" "}
          <Route
            path="/blog/decision-latency"
            element={<Blog_DecisionLatency />}
          />{" "}
          <Route
            path="/blog/audit-ready-ai-agent-automation"
            element={<Blog_AuditReadyAutomation />}
          />
          <Route
            path="/blog/span-of-control-agentic-ai"
            element={<Blog_SpanOfControl />}
          />
          <Route
            path="/blog/context-switching-tax"
            element={<Blog_ContextSwitchingTax />}
          />
          <Route path="/blog/shadow-ai-at-work" element={<Blog_ShadowAI />} />
          <Route
            path="/blog/onboarding-agentic-runbooks"
            element={<Blog_OnboardingRunbooks />}
          />
          <Route
            path="/blog/capacity-planning-ai-agents"
            element={<Blog_CapacityPlanning />}
          />
          <Route
            path="/blog/ai-agent-escalation-ladder"
            element={<Blog_EscalationLadder />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <SiteFooter />
      </main>
      <BackToTop />
      <BookingOverlay />
      <CookieChoices />
    </BrowserRouter>
  );
}
function ScrollToTop() {
  const location = useLocation();
  const firstRun = useRef(true);
  useEffect(() => {
    // A page that has just loaded is already at the top, and asking it to
    // scroll would force a layout of the whole page. Only route changes scroll.
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    const scroller = document.querySelector(".routeScroll");
    if (scroller) scroller.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);
  return null;
}

function SiteHeader() {
  const [open, setOpen] = useState(null); // desktop menus: "solutions" | "explore" | null
  const [mobileOpen, setMobileOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerMounted, setDrawerMounted] = useState(false);
  const openDrawer = () => {
    setDrawerMounted(true);
    // next frame so the CSS transition runs from off-screen -> 0
    requestAnimationFrame(() => setMobileOpen(true));
  };

  const closeDrawer = () => {
    setMobileOpen(false);
    // unmount after the CSS transition ends (260ms in your CSS)
    setTimeout(() => setDrawerMounted(false), 260);
  };
  useEffect(() => {
    const onDoc = (e) => {
      if (!ref.current || ref.current.contains(e.target)) return;
      setOpen(null);
    };
    const onKey = (e) => {
      if (e.key === "Escape") {
        setOpen(null);
        setMobileOpen(false);
      }
    };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, []);
  useEffect(() => {
    const root = document.documentElement;
    const scroller = document.querySelector(".routeScroll");

    // add/remove a global class for CSS-based locking
    root.classList.toggle("drawer-open", mobileOpen);

    // make background non-interactive while drawer is open
    if (mobileOpen) {
      scroller?.setAttribute("aria-hidden", "true");
      scroller?.setAttribute("inert", ""); // safe if supported; ignored otherwise
    } else {
      scroller?.removeAttribute("aria-hidden");
      scroller?.removeAttribute("inert");
    }

    return () => {
      root.classList.remove("drawer-open");
      scroller?.removeAttribute("aria-hidden");
      scroller?.removeAttribute("inert");
    };
  }, [mobileOpen]);

  // close the mobile drawer when route changes
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  // lock body scroll when drawer is open
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = mobileOpen ? "hidden" : prev || "";
    return () => (document.body.style.overflow = prev || "");
  }, [mobileOpen]);

  // close drawer if user resizes to desktop
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 900) setMobileOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  /*   useEffect(() => {
    const isTouch = window.matchMedia?.(
      "(hover: none) and (pointer: coarse)"
    )?.matches;

    const apply = () => {
      if (!isTouch || !window.visualViewport) {
        document.documentElement.classList.remove("bd-mobile-vv");
        document.documentElement.style.removeProperty("--vh");
        return;
      }
      // iOS Safari bug: innerHeight != visual viewport height when bottom bar overlaps
      const clipped =
        Math.abs(window.innerHeight - window.visualViewport.height) > 2;

      if (clipped) {
        const vh = window.visualViewport.height * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
        document.documentElement.classList.add("bd-mobile-vv");
      } else {
        document.documentElement.classList.remove("bd-mobile-vv");
        document.documentElement.style.removeProperty("--vh");
      }
    };

    apply();
    window.addEventListener("resize", apply);
    window.addEventListener("orientationchange", apply);
    window.visualViewport?.addEventListener("resize", apply);
    return () => {
      window.removeEventListener("resize", apply);
      window.removeEventListener("orientationchange", apply);
      window.visualViewport?.removeEventListener("resize", apply);
    };
  }, []); */
  // iOS keyboard-safe viewport + "keyboard-open" class
  useEffect(() => {
    const root = document.documentElement;
    const vv = window.visualViewport;

    const update = () => {
      const h = vv ? vv.height : window.innerHeight;
      // keep a robust --vh (in px) for legacy engines
      root.style.setProperty("--vh", `${h * 0.01}px`);

      // detect keyboard (shrink > ~120px is a good heuristic)
      const kbOpen = vv ? window.innerHeight - h > 120 : false;
      root.classList.toggle("kbd-open", kbOpen);
    };

    // Reading viewport sizes during load forces a layout. Only browsers without
    // dvh use --vh (index.css), and no keyboard is open yet, so the rest wait for
    // the first resize. The others read once, after paint.
    const cancelFirstRead = window.CSS?.supports?.("height", "100dvh")
      ? null
      : afterPaint(update);
    window.addEventListener("resize", update);
    vv?.addEventListener("resize", update);
    vv?.addEventListener("scroll", update); // fires during keyboard animation

    return () => {
      cancelFirstRead?.();
      window.removeEventListener("resize", update);
      vv?.removeEventListener("resize", update);
      vv?.removeEventListener("scroll", update);
    };
  }, []);

  const goToAnchor = (href) => {
    const [path, hash] = href.split("#");
    const doScroll = () =>
      document
        .querySelector(`#${hash}`)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    if (path && path !== location.pathname) {
      navigate(path);
      setTimeout(doScroll, 0);
    } else {
      if (path && !hash) navigate(path);
      if (hash) doScroll();
    }
  };

  const openMenu = (name) => setOpen(name);
  const toggleMenu = (name) => setOpen((o) => (o === name ? null : name));
  const closeIfCurrent = (name) => setOpen((o) => (o === name ? null : o));
  const immediateClose = () => setOpen(null);

  const solutionsItems = [
    { label: "Enterprise", to: "/enterprise" },
    { label: "Teams", to: "/teams" },
  ];
  const exploreItems = [
    { label: "Book a demo", booking: true },
    { label: "Features", to: "/features" },
    { label: "How it works", to: "/how-it-works" },
    { label: "Contact", to: "/contact" },
  ];

  return (
    <>
      <header className="siteHeader" ref={ref}>
        <NavLink
          className="brand"
          to="/"
          aria-label="BossDrop home"
          onMouseEnter={immediateClose}
          onFocus={immediateClose}
        >
          <img
            className="brandLogo"
            src={bossdroplogo} // <- replace with your path
            srcSet={LOGO_SRCSET}
            alt="" // decorative (link already has aria-label)
            width="190"
            height="38" // set your intrinsic size to prevent CLS
            decoding="async"
            fetchpriority="high"
          />
        </NavLink>

        {/* Desktop nav */}
        <nav className="topNav desktopOnly">
          <NavLink
            to="/"
            end
            onMouseEnter={immediateClose}
            onFocus={immediateClose}
          >
            Home
          </NavLink>

          <Menu
            id="solutions"
            label="Solutions"
            open={open === "solutions"}
            onOpen={openMenu}
            onToggle={toggleMenu}
            onClose={closeIfCurrent}
            onAnchor={goToAnchor}
            items={solutionsItems}
          />

          <Menu
            id="explore"
            label="Explore"
            open={open === "explore"}
            onOpen={openMenu}
            onToggle={toggleMenu}
            onClose={closeIfCurrent}
            onAnchor={goToAnchor}
            items={exploreItems}
          />

          <NavLink
            to="/pricing"
            onMouseEnter={immediateClose}
            onFocus={immediateClose}
          >
            Pricing
          </NavLink>
        </nav>

        {/* Desktop CTA */}
        <a
          {...DEMO_LINK}
          className="btn btnPrimary desktopOnly"
          onMouseEnter={immediateClose}
          onFocus={immediateClose}
        >
          Book a demo
        </a>

        {/* Mobile hamburger */}
        <button
          type="button"
          className="hamburger mobileOnly"
          aria-label="Open menu"
          aria-controls="mobile-drawer"
          aria-expanded={mobileOpen ? "true" : "false"}
          onClick={openDrawer}
        >
          <HamburgerIcon />
        </button>
      </header>

      {/* Mobile Drawer */}
      {drawerMounted && (
        <MobileNav
          open={mobileOpen}
          onClose={closeDrawer}
          onAnchor={(href) => {
            setMobileOpen(false);
            goToAnchor(href);
          }}
        />
      )}
    </>
  );
}

function MobileNav({ open, onClose, onAnchor }) {
  const firstLinkRef = useRef(null);

  useEffect(() => {
    if (open) {
      // basic focus management
      setTimeout(() => firstLinkRef.current?.focus(), 10);
    }
  }, [open]);

  return (
    <>
      <div
        className={`drawerOverlay ${open ? "open" : ""}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <aside
        id="mobile-drawer"
        className={`drawer ${open ? "open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label="Site navigation"
      >
        <div className="drawerHeader">
          <a className="brand" href="/" onClick={onClose}>
            BossDrop
          </a>
          <button
            className="closeBtn"
            onClick={onClose}
            aria-label="Close menu"
            type="button"
          >
            ✕
          </button>
        </div>

        <nav className="drawerNav">
          <NavLink to="/" end onClick={onClose} ref={firstLinkRef}>
            Home
          </NavLink>

          <div className="drawerGroup">
            <div className="groupLabel">Solutions</div>
            <NavLink to="/enterprise" onClick={onClose}>
              Enterprise
            </NavLink>
            <NavLink to="/teams" onClick={onClose}>
              Teams
            </NavLink>
          </div>

          <div className="drawerGroup">
            <div className="groupLabel">Explore</div>
            <a
              {...DEMO_LINK}
              className="anchorLink"
              onClick={(e) => {
                openBooking(e);
                onClose();
              }}
            >
              Book a demo
            </a>
            <NavLink to="/features" onClick={onClose}>
              Features
            </NavLink>
            <NavLink to="/how-it-works" onClick={onClose}>
              How it works
            </NavLink>
            <button
              type="button"
              className="anchorLink"
              onClick={() => onAnchor("/contact")}
            >
              Contact
            </button>
          </div>

          <NavLink to="/pricing" onClick={onClose}>
            Pricing
          </NavLink>
        </nav>

        <a
          {...DEMO_LINK}
          className="btn btnPrimary wideBtn"
          onClick={(e) => {
            openBooking(e);
            onClose();
          }}
        >
          Book a demo
        </a>

        <div className="drawerFoot muted">
          © {new Date().getFullYear()} BossDrop, Inc.
        </div>
      </aside>
    </>
  );
}

function HamburgerIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M3 6h18M3 12h18M3 18h18"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function Menu({ id, label, open, onOpen, onToggle, onClose, onAnchor, items }) {
  const closeTimer = useRef(null);
  const LEAVE_DELAY = 240; // ms of leeway before closing

  const clear = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  };
  const safeOpen = () => {
    clear();
    onOpen(id);
  };
  const scheduleClose = () => {
    clear();
    closeTimer.current = setTimeout(() => {
      onClose(id); // only closes if this is still the active menu
      closeTimer.current = null;
    }, LEAVE_DELAY);
  };

  // Desktop hover; mobile click
  const enter = () => (window.innerWidth > 900 ? safeOpen() : null);
  const leave = () => (window.innerWidth > 900 ? scheduleClose() : null);

  return (
    <div
      className="menu"
      data-open={open ? "true" : "false"}
      onMouseEnter={enter}
      onMouseLeave={leave}
      onFocus={safeOpen}
      onBlur={(e) => {
        if (!e.currentTarget.contains(e.relatedTarget)) onClose(id);
      }}
    >
      <button
        type="button"
        className="menu-trigger"
        aria-haspopup="menu"
        aria-expanded={open ? "true" : "false"}
        onClick={() => {
          clear();
          onToggle(id);
        }}
      >
        <span>{label}</span>
        <ChevronDown />
      </button>

      {/* Keep open when moving between trigger and panel */}
      <div
        className="dropdown-panel"
        role="menu"
        onMouseEnter={enter}
        onMouseLeave={leave}
      >
        <ul className="dropdown-list">
          {items.map((it) => (
            <li key={it.label}>
              {it.booking ? (
                <a
                  {...DEMO_LINK}
                  role="menuitem"
                  onClick={(e) => {
                    openBooking(e);
                    onClose(id);
                  }}
                >
                  {it.label}
                </a>
              ) : it.anchor ? (
                <a
                  href={it.to}
                  role="menuitem"
                  onClick={(e) => {
                    e.preventDefault();
                    onClose(id); // close immediately
                    onAnchor?.(it.to); // smooth-scroll to anchor
                  }}
                >
                  {it.label}
                </a>
              ) : (
                <NavLink
                  to={it.to}
                  role="menuitem"
                  onClick={() => onClose(id)} // close on click
                >
                  {it.label}
                </NavLink>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function ChevronDown() {
  return (
    <svg
      className="chev"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M6 9l6 6 6-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function SiteFooter() {
  return (
    <footer className="siteFooter siteFooter--columns">
      {/* Left: brand only (no menus here) */}
      <div className="foot-col foot-brandcol">
        <a className="brandRow" href="/" aria-label="BossDrop home">
          <img
            className="foot-logo"
            src={bossdroplogo}
            srcSet={LOGO_SRCSET}
            alt=""
            width="180"
            height="36" // preserve intrinsic ratio (width auto in CSS)
            decoding="async"
            loading="lazy"
          />
        </a>

        {/* optional badges; keep/remove as needed */}
        <div className="foot-badges">
          {/* <img src="/images/gdpr.svg" alt="GDPR" /> */}
          {/* <img src="/images/soc2.svg" alt="SOC 2" /> */}
        </div>

        <div className="copyright muted">
          © {new Date().getFullYear()} BossDrop, Inc.
        </div>
      </div>

      {/* Company (now its own column) */}
      <div className="foot-col">
        <div className="foot-title">Contact</div>
        <div className="foot-list">
          <a className="contactEmail" href="mailto:sales@bossdrop.ai">
            sales@bossdrop.ai
          </a>
          <a className="contactEmail" href="mailto:support@bossdrop.ai">
            support@bossdrop.ai
          </a>
        </div>
      </div>

      {/* Product */}
      <div className="foot-col">
        <div className="foot-title">Product</div>
        <div className="foot-list">
          <NavLink to="/pricing">Pricing</NavLink>
          <NavLink to="/features">Features</NavLink>
          <NavLink to="/how-it-works">How it works</NavLink>
          <a {...DEMO_LINK}>Book a demo</a>
        </div>
      </div>

      {/* Resources */}
      <div className="foot-col">
        <div className="foot-title">Resources</div>
        <div className="foot-list">
          <NavLink to="/blog">Blog</NavLink>
          <NavLink to="/specialists">Become a specialist</NavLink>
          {/* Plain <a>: a full page load, so the sign-in page starts with no
              analytics tags (public/index.html). */}
          <a href="/specialists/login">Specialist log in</a>
          {/* Plain <a>, not NavLink: React Router would intercept the click
              and try to route to a PDF path that has no route. */}
          <a href="/bossdrop-resume.pdf" target="_blank" rel="noopener">
            BossDrop resume (PDF)
          </a>
          <NavLink to="/privacy">Privacy</NavLink>
          <NavLink to="/terms">Terms</NavLink>
        </div>
      </div>

      {/* Compare */}
      <div className="foot-col">
        <div className="foot-title">Compare</div>
        <div className="foot-list">
          <NavLink to="/compare/viktor">vs Viktor</NavLink>
          <NavLink to="/compare/motion">vs Motion</NavLink>
          <NavLink to="/compare/clickup">with ClickUp</NavLink>
          <NavLink to="/compare/monday">with monday.com</NavLink>
          <NavLink to="/compare/wrike">vs Wrike</NavLink>
        </div>
      </div>
    </footer>
  );
}

function NotFound() {
  return (
    <section className="page container">
      <div className="hero">
        <h1 className="h1">Page not found</h1>
        <p className="sub">Try the links in the header above.</p>
      </div>
    </section>
  );
}

function Backdrop() {
  return (
    <div className="bgOrbs" aria-hidden="true">
      <span className="orb o1" />
      <span className="orb o2" />
      <span className="orb o3" />
      <span className="orb o4" />
      <span className="orb o5" />
      <span className="orb o6" />
    </div>
  );
}

/** Bootstraps fade-in/up on scroll for anything with [data-reveal] */
function RevealOnScroll() {
  const location = useLocation();

  useEffect(() => {
    const scroller = document.querySelector(".routeScroll");
    if (!scroller) return;

    // Collect fresh reveal targets on each route
    const els = Array.from(document.querySelectorAll("[data-reveal], .reveal"));

    // Reset visibility
    els.forEach((el) => el.classList.remove("is-visible"));

    // Show hero (or anything marked data-instant) immediately
    els.forEach((el) => {
      if (el.closest(".bd-hero") || el.hasAttribute("data-instant")) {
        el.classList.add("is-visible");
      }
      const delay = el.getAttribute("data-delay");
      if (delay) el.style.setProperty("--d", delay);
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            const el = e.target;
            el.classList.add("is-visible");
            // Drop will-change after the transition to free memory
            el.addEventListener("transitionend", function handler() {
              el.style.willChange = "auto";
              el.removeEventListener("transitionend", handler);
            });
            io.unobserve(el);
          }
        });
      },
      { root: scroller, threshold: 0.12, rootMargin: "0px 0px -10% 0px" },
    );

    els
      .filter((el) => !el.classList.contains("is-visible"))
      .forEach((el) => io.observe(el));

    return () => io.disconnect();
  }, [location.pathname]);

  return null;
}
